// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__k0SzC","additionalInfo":"AgreementModal_additionalInfo__33w3F"};